<ion-row
  *ngIf="
    this.platformService?.platformType !==
    this.platformService?.platformEnum?.mobile
  "
>
  <!--Spinner Template-->
  <ng-template #spinner>
    <ion-spinner
      name="circles"
      class="order-spinner"
      data-cy="loading-spinner"
    ></ion-spinner>
  </ng-template>

  <ion-col size-xl="12" size-l="12" size-md="12" size-s="12" size-xs="12">
    <div class="order-submitted-title-and-status">
      <div>
        <h1 data-cy="submitted-order-number-text">
          {{ 'i18n.orderSubmittedPage.orderNum' | translate
          }}{{ orderHeader?.tandemOrderNumber }}
        </h1>
        <app-order-status-info
          [orderHeader]="orderHeader"
          [orderItems]="orderItems"
          [title]="displayTitle"
          [icon]="orderStatusDetails?.icon"
          [restrictToOG]="restrictToOG"
          [orderStatusDetails]="orderStatusDetails"
        ></app-order-status-info>
        <!-- if delivery hasETADetails use etaRange for delivered time. -->
        <h3
          *ngIf="
            !orderHeader?.orderDelivered &&
              hasETADetails &&
              orderHeader?.deliveryEta &&
              isValidDate(orderHeader?.deliveryEta) &&
              !((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta);
            else hideEtaRange
          "
          data-cy="submitted-order-delivered-text"
          class="delivery-date order-eta-title"
        >
          {{ 'i18n.orderPage.WMTeta1' | translate }}
          {{ orderHeader?.deliveryEta | date: 'M/d' : customerTimeZone }}
          {{ 'i18n.orderPage.WMTeta2' | translate }}
          {{
            orderHeader?.etaRangeMinimum
              | timezoneDate: 'h:mm a' : customerTimeZone
          }}
          -
          {{
            orderHeader?.etaRangeMaximum
              | timezoneDate: 'h:mm a' : customerTimeZone : true
          }}
          <p
            *ngIf="orderHeader?.etaMessageType === orderETAMessageType.PLANNED"
            class="planned-text"
          >
            {{ 'i18n.orderSubmittedPage.etaPlanned' | translate }}
          </p>
        </h3>

        <ng-template #hideEtaRange>
          <h3
            *ngIf="
              !orderHeader?.orderDelivered &&
              !hasETADetails &&
              orderHeader?.deliveryEta &&
              isValidDate(orderHeader?.deliveryEta) &&
              !((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta)
            "
            data-cy="submitted-order-delivered-text"
            class="delivery-date order-eta-title"
          >
            {{ 'i18n.orderPage.WMTeta1' | translate }}
            {{ orderHeader?.deliveryEta | date: 'M/d' : customerTimeZone }}

            <p
              *ngIf="
                orderHeader?.etaMessageType === orderETAMessageType.PLANNED
              "
              class="planned-text"
            >
              {{ 'i18n.orderSubmittedPage.etaPlanned' | translate }}
            </p>
          </h3>
        </ng-template>

        <!-- if orderDelivered is true, use deliveredDtm for delivered time. -->
        <!-- otherwise use WMT data for delivery time -->
        <h3>
          <app-orders-list-delivered
            *ngIf="
              orderHeader?.orderType === 'VS' &&
              orderHeader?.displayOrderStatus === orderStatusEnum.DELIVERED &&
              !!orderHeader?.confirmedDeliveryDate
            "
            [orderHeader]="orderHeader"
            class="delivery-date"
          ></app-orders-list-delivered>
        </h3>
        <h3
          *ngIf="
            !!orderHeader?.deliveredDtm &&
            !!orderHeader?.orderDelivered &&
            orderHeader?.displayOrderStatus !== orderStatusEnum.DELIVERED &&
            !((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta)
          "
          [hidden]="!orderHeader?.deliveredDtm"
          data-cy="submitted-order-delivered-text"
          class="delivery-date"
        >
          <ng-container *ngIf="!willCallInFlight; else spinner">
            {{ this.convertTz(orderHeader?.deliveredDtm) | date: 'longDate' }}
            at
            {{
              orderHeader?.deliveredDtm
                | timezoneDate: 'h:mm a' : customerTimeZone
            }}
            {{ this.customerTimeZone ? this.customerTimeZone : 'CT' }}
          </ng-container>
        </h3>
        <h3
          *ngIf="
            !orderHeader?.deliveredDtm &&
            orderHeader?.orderDelivered &&
            !!orderHeader?.etaRoute &&
            !((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta)
          "
          data-cy="submitted-order-delivered-text"
          class="delivery-date"
        >
          {{ 'i18n.orderPage.arrivedToday' | translate }}
        </h3>

        <h3
          *ngIf="
            !!orderHeader?.deliveredDtm &&
            !!orderHeader?.orderDelivered &&
            (hideEtaGlobalFeatureFlag$ | async) &&
            orderHeader?.hideEta
          "
          data-cy="submitted-order-delivered-text"
          class="delivery-date"
        >
          <ng-container *ngIf="!willCallInFlight; else spinner">
            {{ 'i18n.orderSubmittedPage.expectedBy' | translate }}
            <ng-container
              *ngIf="
                !willCallInFlight &&
                  (orderHeader?.orderType === 'RT' ||
                    orderHeader?.orderType === 'WC');
                else spinner
              "
            >
              <ng-container
                *ngIf="
                  platformType === platformService?.platformEnum.desktop;
                  else tabletDateFormat
                "
              >
                {{
                  this.convertTz(orderHeader?.confirmedDeliveryDate)
                    | date: 'fullDate' : 'GMT'
                }}
              </ng-container>
              <ng-template #tabletDateFormat>
                {{
                  this.convertTz(orderHeader?.confirmedDeliveryDate)
                    | date: 'M/d/yyyy' : 'GMT'
                }}
              </ng-template>
            </ng-container>
          </ng-container>
        </h3>
        <h3
          *ngIf="
            (!(
              orderHeader?.deliveryEta && isValidDate(orderHeader?.deliveryEta)
            ) ||
              ((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta)) &&
            !isDelivered &&
            !orderHeader?.orderDelivered &&
            orderHeader?.displayOrderStatus !== orderStatusEnum.DELIVERED &&
            (!(
              orderHeader?.orderType === 'VS' &&
              (!!orderHeader?.orderTracking?.length ||
                orderHeader?.trackingAvailable)
            ) ||
              (orderStatusDisplayEnabled && orderHeader?.orderType === 'VS'))
          "
          class="delivery-date"
        >
          <strong
            *ngIf="orderHeader?.orderType === 'VS'; else deliveryDateHandle"
            data-cy="submitted-order-delivered-text"
            [hidden]="!orderHeader?.confirmedDeliveryDate"
            class="delivery-date"
          >
            {{ 'i18n.orderPage.vendorOrderExpectDelivery' | translate }}:
            <ng-container *ngIf="!willCallInFlight; else spinner">
              <ng-container
                *ngIf="
                  orderHeader?.displayOrderStatus !==
                    orderStatusEnum.ORDER_CANCELLED;
                  else cancelledOrder
                "
              >
                {{
                  this.convertTz(orderHeader?.confirmedDeliveryDate)
                    | date: 'M/d/yyyy' : 'GMT'
                    | lowercase
                }}
              </ng-container>
              <ng-template #cancelledOrder> N/A </ng-template>
            </ng-container>
          </strong>
          <ng-template #deliveryDateHandle>
            <!--Scheduled Date-->
            <ng-container *ngIf="orderHeader?.orderType === 'WC'">
              <ng-container *appShowSplit="[convertToWillCallFeatureFlag]">
                <ng-container
                  *ngIf="
                    !hasETADetails &&
                    !(
                      (hideEtaGlobalFeatureFlag$ | async) &&
                      orderHeader?.hideEta
                    )
                  "
                >
                  {{ 'i18n.orderPage.willCallPickUpDate' | translate }}:
                  <ng-container
                    *ngIf="
                      !willCallInFlight && orderHeader?.orderType === 'WC';
                      else spinner
                    "
                  >
                    {{
                      orderHeader?.willCallDateTime | date: 'EEEE, M/d' : 'GMT'
                    }}
                    at
                    {{
                      orderHeader?.willCallDateTime
                        | date: 'h:mm a' : 'GMT'
                        | lowercase
                    }}
                  </ng-container>
                </ng-container>

                <ng-container
                  *ngIf="
                    hasETADetails &&
                    (hideEtaGlobalFeatureFlag$ | async) &&
                    orderHeader?.hideEta
                  "
                >
                  {{ 'i18n.orderSubmittedPage.expectedBy' | translate }}
                  <ng-container
                    *ngIf="
                      platformType === platformService?.platformEnum.desktop;
                      else tabletDateFormat
                    "
                  >
                    {{
                      this.convertTz(orderHeader?.confirmedDeliveryDate)
                        | date: 'fullDate' : 'GMT'
                    }}
                  </ng-container>
                  <ng-template #tabletDateFormat>
                    {{
                      this.convertTz(orderHeader?.confirmedDeliveryDate)
                        | date: 'M/d/yyyy' : 'GMT'
                    }}
                  </ng-template>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-template>
          <div
            *ngIf="
              orderHeader?.orderType !== 'WC' &&
              orderHeader?.orderType !== 'VS' &&
              !orderHeader?.orderDelivered
            "
            [hidden]="!orderHeader?.confirmedDeliveryDate"
            data-cy="submitted-order-delivered-text"
            class="delivery-date"
          >
            {{ 'i18n.orderSubmittedPage.expectedBy' | translate }}
            <ng-container
              *ngIf="
                !willCallInFlight &&
                  !shipToInFlight &&
                  (orderHeader?.orderType === 'RT' ||
                    orderHeader?.orderType === 'CC');
                else spinner
              "
            >
              <ng-container
                *ngIf="
                  platformType === platformService?.platformEnum.desktop;
                  else tabletDateFormat
                "
              >
                {{
                  this.convertTz(orderHeader?.confirmedDeliveryDate)
                    | date: 'fullDate' : 'GMT'
                }}
              </ng-container>
              <ng-template #tabletDateFormat>
                {{
                  this.convertTz(orderHeader?.confirmedDeliveryDate)
                    | date: 'M/d/yyyy' : 'GMT'
                }}
              </ng-template>
            </ng-container>
          </div>
        </h3>

        <div
          *ngIf="orderHeader?.etaReasonLong?.trim()"
          class="route-info-message-text"
        >
          {{ orderHeader?.etaReasonLong }}
        </div>

        <div
          *ngIf="
            isDelivered &&
            !!orderHeader?.etaRoute &&
            !((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta)
          "
          class="route-number"
          data-cy="route-number"
        >
          {{ 'i18n.orderPage.route' | translate }} {{ orderHeader?.etaRoute }}
        </div>

        <div data-cy="order-details-action-buttons">
          <ng-container
            *ngIf="
              this.platformService?.platformType ===
              this.platformService?.platformEnum?.desktop
            "
          >
            <ng-container
              *ngIf="
                orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS' &&
                displayTitle !== 'Delivered' &&
                !orderHeader.displayOrderStatus &&
                isEditable
              "
            >
              <ion-button
                id="resolve-exceptions-btn"
                class="usf-fill-orange-button header-button"
                data-cy="resolve-order-page-exceptions-button"
                (click)="navigateToOrderExceptions()"
              >
                {{ 'i18n.orderPage.resolveExceptions' | translate }}
              </ion-button>
            </ng-container>
            <ng-container *ngIf="showTransferButton">
              <ion-button
                data-cy="transfer-button"
                class="usf-fill-green-button header-button transfer-button"
                (click)="transferOrderModal()"
              >
                {{
                  transferButtonText
                    ? transferButtonText
                    : ('i18n.orderPage.transferBtn' | translate)
                }}
              </ion-button>
            </ng-container>

            <ng-container *ngIf="isEditable">
              <ion-button
                [class.usf-fill-green-button]="!showTransferButton"
                [class.usf-outline-green-button]="showTransferButton"
                class="header-button"
                data-cy="edit-submitted-order-button"
                (click)="editSubmittedOrder()"
              >
                {{
                  modifyButtonText
                    ? modifyButtonText
                    : ('i18n.orderPage.modifyOrder' | translate)
                }}
              </ion-button>
            </ng-container>

            <ng-container
              *ngIf="
                isInternalUser &&
                orderHeader?.orderType === 'RT' &&
                orderHeader?.orderModifiable
              "
            >
              <ion-button
                id="convert-will-call"
                [disabled]="(isOnline$ | async) === false"
                class="usf-outline-green-button header-button"
                (click)="willCallModalOpen()"
                data-cy="convert-to-will-call-button"
                >{{
                  'i18n.convertToWillCall.convertToWillCall' | translate
                }}</ion-button
              >
            </ng-container>

            <ng-container
              *ngIf="isInternalUser && orderHeader?.orderType === 'WC'"
            >
              <ion-button
                [disabled]="(isOnline$ | async) === false"
                class="usf-outline-green-button header-button"
                (click)="willCallModalOpen()"
                data-cy="open-will-call-modal-button"
                >{{
                  'i18n.convertToWillCall.editWillCallDetails' | translate
                }}</ion-button
              >
            </ng-container>

            <ng-container
              *appShowSplit="[features.split_division_order_shipto_button.name]"
            >
              <ion-button
                *ngIf="
                  isInternalUser &&
                  orderHeader?.orderType === 'RT' &&
                  orderHeader?.orderModifiable &&
                  (customersWithTheSameDivision > 1 || (isSuperUser$() | async))
                "
                id="ship-to"
                [disabled]="(isOnline$ | async) === false"
                class="usf-outline-green-button header-button"
                data-cy="modify-ship-to-button"
                (click)="shipToModalOpen()"
                >{{ 'i18n.orderStatusPage.shipTo' | translate }}</ion-button
              >
            </ng-container>

            <ng-container *appShowSplit="[recoveryBtnDivisionFeatureFlag]">
              <ion-button
                *ngIf="
                  orderHeader?.orderType === 'RT' &&
                  isInternalUser &&
                  isEditable
                "
                [disabled]="(isOnline$ | async) === false"
                class="usf-outline-green-button header-button"
                data-cy="recovery-order-button"
                (click)="recoveryModalOpen()"
              >
                {{ 'i18n.orderSubmittedPage.recoveryBtn' | translate }}
              </ion-button>
            </ng-container>

            <ng-container *appShowSplit="[insightsOrderLinkFeatureFlag]">
              <ion-button
                *ngIf="
                  orderHeader?.orderType === 'RT' &&
                  isInternalUser &&
                  (insightsItems?.length > 0 ||
                    orderHeader?.cookbookAdoptionPercent >= 0) &&
                  (panAppState.online$ | async) === true
                "
                class="usf-outline-green-button header-button"
                data-cy="insights-order-button"
                (click)="navigateToOrderInsightsPage()"
              >
                {{ 'i18n.orderStatusPage.orderInsights' | translate }}
                <div *ngIf="insightsItems?.length > 0">
                  <ion-badge
                    [ngClass]="
                      insightsItems.length > 9
                        ? 'insights-badge-multi-digit'
                        : 'insights-badge-single-digit'
                    "
                    data-cy="insights-single-count-badge"
                  >
                    {{ insightsItems.length > 99 ? 99 : insightsItems.length }}
                  </ion-badge>
                </div>
              </ion-button>
            </ng-container>

            <ng-container *ngIf="isCancellable">
              <ion-button
                class="usf-outline-orange-button header-button"
                data-cy="cancel-submitted-order-button"
                (click)="cancelOrderModal()"
              >
                {{ 'i18n.orderPage.cancelOrder' | translate }}
              </ion-button>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <div>
        <div class="order-submitted-button-status">
          <ng-container>
            <ion-button
              class="btn-share"
              data-cy="share-order-button"
              (click)="shareOrder($event)"
              fill="clear"
              [disabled]="willCallInFlight || shipToInFlight"
            >
              <ion-icon name="share-social-outline"></ion-icon>
              {{ 'i18n.orderPage.share' | translate }}
            </ion-button>
          </ng-container>
          <ng-container>
            <ion-button
              class="btn-print"
              data-cy="print-order-button"
              (click)="printOrder($event)"
              fill="clear"
              [disabled]="willCallInFlight || shipToInFlight"
            >
              <ion-icon name="print-outline"></ion-icon>
              {{ 'i18n.orderPage.print' | translate }}
            </ion-button>
          </ng-container>
          <ng-container>
            <ion-button
              class="btn-download"
              data-cy="download-order-button"
              (click)="downloadOrderModalOpen()"
              fill="clear"
              [disabled]="willCallInFlight || shipToInFlight"
            >
              <ion-icon name="download-outline"></ion-icon>
              {{ 'i18n.orderPage.download' | translate }}
            </ion-button>
          </ng-container>
        </div>
        <div
          *ngIf="
            !isDelivered &&
            !orderHeader?.orderDelivered &&
            !hasETADetails &&
            !orderHeader?.etaRoute &&
            isOnMinimumOrderMetFlag &&
            !!orderMinimumDetails &&
            !orderMinimumDetails.hasOnlyVSItems &&
            !orderMinimumDetails.isMet &&
            orderHeader?.orderType === 'RT' &&
            (orderHeader?.orderStatus === 'SUBMITTED' ||
              orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
              orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS') &&
            platformType === platformService?.platformEnum.desktop
          "
          class="order-minimum-container"
          data-cy="order-minimum-section-desktop"
        >
          <strong *ngIf="isProntoDeliveryCustomer; else originalMinRemaining">
            {{ 'i18n.confirmationPage.orderMinRemainingPronto' | translate }}:
          </strong>
          <ng-template #originalMinRemaining>
            <strong>
              {{ 'i18n.confirmationPage.orderMinRemaining' | translate }}:
            </strong>
          </ng-template>
          <div>
            <span *ngIf="orderMinimumDetails.remainingDollars > 0">
              {{ orderMinimumDetails.remainingDollars || 0 | currency }}
            </span>

            <span
              *ngIf="
                orderMinimumDetails.remainingDollars > 0 &&
                orderMinimumDetails.remainingCases > 0
              "
              class="mini-border"
            >
              |
            </span>

            <span *ngIf="orderMinimumDetails.remainingCases > 0">
              {{ orderMinimumDetails.remainingCases || 0 }}
              CS
            </span>
          </div>
          <p class="order-minimum-pronto-desc" *ngIf="isProntoDeliveryCustomer">
            {{
              'i18n.confirmationPage.orderMinRemainingProntoDesc' | translate
            }}
          </p>
        </div>
      </div>
    </div>
  </ion-col>
</ion-row>

<ng-container>
  <ng-container
    *ngIf="
      (orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS' &&
        displayTitle !== 'Delivered') ||
      orderHeader?.orderType === 'RT' ||
      orderHeader?.orderType === 'WC'
    "
  >
    <ion-row>
      <div
        class="will-call-delivery-method"
        data-cy="will-call-delivery-method-text"
        *ngIf="isInternalUser && orderHeader?.orderType === 'WC'"
      >
        {{ 'i18n.convertToWillCall.willCallDeliveryMethod' | translate }}
      </div>
    </ion-row>
  </ng-container>
</ng-container>
<div
  *ngIf="
    orderHeader?.etaReasonLong?.trim() &&
    platformType === platformService?.platformEnum.mobile
  "
  class="route-info-message-text"
>
  {{ orderHeader?.etaReasonLong }}
</div>

<div
  class="mobile-button-group"
  *ngIf="platformType !== platformService?.platformEnum.desktop"
>
  <ng-container
    *ngIf="
      orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS' &&
      displayTitle !== 'Delivered' &&
      !orderHeader.displayOrderStatus &&
      isEditable
    "
  >
    <ion-button
      id="resolve-exceptions-btn"
      class="usf-fill-orange-button header-button"
      data-cy="resolve-order-page-exceptions-button"
      (click)="navigateToOrderExceptions()"
    >
      {{ 'i18n.orderPage.resolveExceptions' | translate }}
    </ion-button>
  </ng-container>

  <ng-container *ngIf="showTransferButton">
    <ion-button
      data-cy="transfer-button"
      class="usf-fill-green-button header-button transfer-button"
      (click)="transferOrderModal()"
    >
      {{
        transferButtonText
          ? transferButtonText
          : ('i18n.orderPage.transferBtn' | translate)
      }}
    </ion-button>
  </ng-container>

  <ng-container *ngIf="isEditable">
    <ion-button
      [class.usf-fill-green-button]="!showTransferButton"
      [class.usf-outline-green-button]="showTransferButton"
      class="header-button"
      data-cy="edit-submitted-order-button"
      (click)="editSubmittedOrder()"
    >
      {{
        modifyButtonText
          ? modifyButtonText
          : ('i18n.orderPage.modifyOrder' | translate)
      }}
    </ion-button>
  </ng-container>

  <ng-container
    *ngIf="
      isInternalUser &&
      orderHeader?.orderType === 'RT' &&
      orderHeader?.orderModifiable
    "
  >
    <ion-button
      id="convert-will-call"
      [disabled]="(isOnline$ | async) === false"
      class="usf-outline-green-button header-button"
      (click)="willCallModalOpen()"
      data-cy="convert-to-will-call-button"
      >{{ 'i18n.convertToWillCall.convertToWillCall' | translate }}</ion-button
    >
  </ng-container>

  <ng-container *ngIf="isInternalUser && orderHeader?.orderType === 'WC'">
    <ion-button
      [disabled]="(isOnline$ | async) === false"
      class="usf-outline-green-button header-button"
      (click)="willCallModalOpen()"
      data-cy="open-will-call-modal-button"
      >{{
        'i18n.convertToWillCall.editWillCallDetails' | translate
      }}</ion-button
    >
  </ng-container>

  <ng-container
    *appShowSplit="[features.split_division_order_shipto_button.name]"
  >
    <ion-button
      *ngIf="
        isInternalUser &&
        orderHeader?.orderType === 'RT' &&
        orderHeader?.orderModifiable &&
        (customersWithTheSameDivision > 1 || (isSuperUser$() | async))
      "
      id="ship-to"
      [disabled]="(isOnline$ | async) === false"
      class="usf-outline-green-button header-button"
      data-cy="modify-ship-to-button"
      (click)="shipToModalOpen()"
      >{{ 'i18n.orderStatusPage.shipTo' | translate }}</ion-button
    >
  </ng-container>

  <ng-container *appShowSplit="[recoveryBtnDivisionFeatureFlag]">
    <ion-button
      *ngIf="orderHeader?.orderType === 'RT' && isInternalUser && isEditable"
      class="usf-outline-green-button header-button"
      [disabled]="(isOnline$ | async) === false"
      data-cy="recovery-order-button"
      (click)="recoveryModalOpen()"
    >
      {{ 'i18n.orderSubmittedPage.recoveryBtn' | translate }}
    </ion-button>
  </ng-container>

  <ng-container *appShowSplit="[insightsOrderLinkFeatureFlag]">
    <ion-button
      *ngIf="
        orderHeader?.orderType === 'RT' &&
        isInternalUser &&
        (insightsItems?.length > 0 ||
          orderHeader?.cookbookAdoptionPercent >= 0) &&
        (panAppState.online$ | async) === true
      "
      class="usf-outline-green-button header-button"
      data-cy="insights-order-button"
      (click)="navigateToOrderInsightsPage()"
    >
      {{ 'i18n.orderStatusPage.orderInsights' | translate }}
      <div *ngIf="insightsItems?.length > 0">
        <ion-badge
          [ngClass]="
            insightsItems.length > 9
              ? 'insights-badge-multi-digit'
              : 'insights-badge-single-digit'
          "
          data-cy="insights-single-count-badge"
        >
          {{ insightsItems.length > 99 ? 99 : insightsItems.length }}
        </ion-badge>
      </div>
    </ion-button>
  </ng-container>

  <ng-container *ngIf="isCancellable">
    <ion-button
      class="usf-outline-orange-button header-button"
      data-cy="cancel-submitted-order-button"
      (click)="cancelOrderModal()"
    >
      {{ 'i18n.orderPage.cancelOrder' | translate }}
    </ion-button>
  </ng-container>
</div>

<ion-row>
  <ion-col
    *ngIf="
      !isDelivered &&
      !orderHeader?.orderDelivered &&
      !hasETADetails &&
      !orderHeader?.etaRoute &&
      isOnMinimumOrderMetFlag &&
      !!orderMinimumDetails &&
      !orderMinimumDetails.hasOnlyVSItems &&
      !orderMinimumDetails.isMet &&
      orderHeader?.orderType === 'RT' &&
      (orderHeader?.orderStatus === 'SUBMITTED' ||
        orderHeader?.orderStatus === 'SUBMITTED_CREDIT_HOLD' ||
        orderHeader?.orderStatus === 'SUBMITTED_WITH_EXCEPTIONS') &&
      platformType !== platformService?.platformEnum.desktop
    "
    size-xl="12"
    size-l="12"
    size-md="12"
    size-s="12"
    size-xs="12"
  >
    <div class="order-minimum" data-cy="order-minimum-section-tablet-mobile">
      <strong *ngIf="isProntoDeliveryCustomer; else originalMinRemaining">
        {{ 'i18n.confirmationPage.orderMinRemainingPronto' | translate }}:
      </strong>
      <ng-template #originalMinRemaining>
        <strong>
          {{ 'i18n.confirmationPage.orderMinRemaining' | translate }}:
        </strong>
      </ng-template>
      <div class="remaining">
        <span *ngIf="orderMinimumDetails.remainingDollars > 0">
          {{ orderMinimumDetails.remainingDollars || 0 | currency }}
        </span>

        <span
          *ngIf="
            orderMinimumDetails.remainingDollars > 0 &&
            orderMinimumDetails.remainingCases > 0
          "
          class="mini-border"
        >
          |
        </span>

        <span *ngIf="orderMinimumDetails.remainingCases > 0">
          {{ orderMinimumDetails.remainingCases || 0 }}
          CS
        </span>
      </div>
    </div>
    <p class="order-minimum-pronto-desc" *ngIf="isProntoDeliveryCustomer">
      {{ 'i18n.confirmationPage.orderMinRemainingProntoDesc' | translate }}
    </p>
  </ion-col>
  <ion-col
    *ngIf="!orderHeader?.orderDelivered"
    size-xl="12"
    size-l="12"
    size-md="12"
    size-s="12"
    size-xs="12"
    class="order-eta-detail-info"
  >
    <ion-row
      *ngIf="!((hideEtaGlobalFeatureFlag$ | async) && orderHeader?.hideEta)"
    >
      <ng-container *ngIf="!!orderHeader?.etaRoute">
        <div
          class="order-info-subtitle"
          data-cy="submitted-order-eta-route-title"
        >
          {{ 'i18n.orderPage.route' | translate }} &nbsp;
        </div>
      </ng-container>
      <div class="order-info-value" data-cy="submitted-order-eta-route-text">
        {{ orderHeader?.etaRoute }}
      </div>
      <ng-container *ngIf="!!orderHeader?.customerStop">
        <ng-container *ngIf="!!orderHeader?.etaRoute">
          <span
            *ngIf="
              this.platformService?.platformType !==
              this.platformService?.platformEnum?.mobile
            "
            class="space-between-with-separator"
          ></span>
          <span
            *ngIf="
              this.platformService?.platformType ===
              this.platformService?.platformEnum?.mobile
            "
            class="break-line-mobile"
          ></span>
        </ng-container>
        <div
          class="order-info-subtitle"
          data-cy="submitted-order-eta-stop-title"
        >
          {{ 'i18n.orderPage.deliveryStop' | translate }} &nbsp;
        </div>
        <div class="order-info-value" data-cy="submitted-order-eta-stop-text">
          {{ 'i18n.orderPage.stopNumber' | translate
          }}{{ orderHeader?.customerStop }}
        </div>
      </ng-container>
      <ng-container
        *ngIf="
          !!orderHeader?.currentStop &&
          orderHeader?.etaMessageType !== orderETAMessageType.PLANNED
        "
      >
        <span
          *ngIf="!!orderHeader?.etaRoute || !!orderHeader?.customerStop"
          class="space-between-with-separator"
        ></span>
        <div
          class="order-info-subtitle"
          data-cy="submitted-order-eta-truck-stop-title"
        >
          {{ 'i18n.orderPage.truckLocation' | translate }} &nbsp;
        </div>
        <div
          class="order-info-value"
          data-cy="submitted-order-eta-truck-stop-text"
        >
          {{ 'i18n.orderPage.atStopNumber' | translate
          }}{{ orderHeader?.currentStop }}
        </div>
      </ng-container>
    </ion-row>
  </ion-col>
  <ion-col size-xl="4" size-l="4" size-md="4" size-s="12" size-xs="12">
    <ion-row>
      <div class="order-info-subtitle" data-cy="submitted-order-total-title">
        {{ 'i18n.orderPage.total' | translate }} &nbsp;
      </div>
      <ng-container
        *ngIf="
          orderHeader?.displayOrderStatus !== orderStatusEnum.ORDER_CANCELLED &&
            orderHeader?.totalPrice !== 0 &&
            customer?.ogPrintPriceInd !== 'N';
          else zeroTotalTag
        "
      >
        <div
          class="order-info-value"
          data-cy="submitted-order-total-price-text"
        >
          {{ tallies?.totalPrice | currency }}
        </div>
      </ng-container>
      <ng-template #zeroTotalTag>
        <div class="order-info-value" data-cy="submitted-order-total-title">
          {{ 'i18n.confirmationPage.notApplicable' | translate }}
        </div>
      </ng-template>
    </ion-row>
    <ion-row>
      <div class="order-info-subtitle" data-cy="submitted-order-eaches-label">
        {{ 'i18n.common.ordered' | translate }}: &nbsp;
      </div>
      <div class="order-info-value" data-cy="submitted-order-eaches-text">
        {{ tallies?.totalCasesOrdered }} {{ 'i18n.orderPage.cs' | translate }} /
        {{ tallies?.totalEachesOrdered }}
        {{ 'i18n.orderPage.ea' | translate }}
      </div>
    </ion-row>
    <ion-row>
      <div class="order-info-subtitle" data-cy="submitted-order-reserved-label">
        {{ 'i18n.common.reserved' | translate }}: &nbsp;
      </div>
      <div class="order-info-value" data-cy="submitted-order-reserved-text">
        <span
          [class.red-text]="
            tallies?.totalCasesReserved < tallies?.totalCasesOrdered
          "
        >
          {{ tallies?.totalCasesReserved || 0 }}
          {{ 'i18n.orderPage.cs' | translate }}
        </span>
        <span
          [class.red-text]="
            tallies?.totalCasesReserved < tallies?.totalCasesOrdered &&
            tallies?.totalEachesReserved < tallies?.totalEachesOrdered
          "
        >
          /
        </span>
        <span
          [class.red-text]="
            tallies?.totalEachesReserved < tallies?.totalEachesOrdered
          "
        >
          {{ tallies?.totalEachesReserved || 0 }}
          {{ 'i18n.orderPage.ea' | translate }}
        </span>
      </div>
    </ion-row>
  </ion-col>
  <ion-col
    *ngIf="showFullInfo"
    size-xl="4"
    size-l="4"
    size-md="4"
    size-s="12"
    size-xs="12"
  >
    <ng-container
      *ngIf="
        this.platformService?.platformType !==
          this.platformService?.platformEnum.tablet;
        else tabletMiddleColumn
      "
    >
      <ion-row>
        <div class="order-info-subtitle" data-cy="submitted-order-type-label">
          {{ 'i18n.orderPage.orderType' | translate }} &nbsp;
        </div>
        <div class="order-info-value" data-cy="submitted-order-type-text">
          {{ orderHeader?.orderType }}
        </div>
      </ion-row>

      <ion-row>
        <div class="order-info-subtitle" data-cy="submitted-order-po-label">
          {{ 'i18n.confirmationPage.poNumber' | translate }} &nbsp;
        </div>
        <div class="order-info-value" data-cy="submitted-order-po-text">
          {{ orderHeader?.purchaseOrderNumber || '-' }}
        </div>
      </ion-row>
    </ng-container>
    <ng-template #tabletMiddleColumn>
      <ion-row>
        <div class="order-info-subtitle" data-cy="submitted-order-po-label">
          {{ 'i18n.confirmationPage.poNumber' | translate }} &nbsp;
        </div>
        <div class="order-info-value" data-cy="submitted-order-po-text">
          {{ orderHeader?.purchaseOrderNumber || '-' }}
        </div>
      </ion-row>
      <ion-row>
        <div class="order-info-subtitle" data-cy="submitted-order-type-label">
          {{ 'i18n.orderPage.orderType' | translate }} &nbsp;
        </div>
        <div class="order-info-value" data-cy="submitted-order-type-text">
          {{ orderHeader?.orderType }}
        </div>
      </ion-row>
    </ng-template>
  </ion-col>
  <ion-col
    *ngIf="showFullInfo"
    size-xl="1"
    size-l="1"
    size-md="1"
    size-s="12"
    size-xs="12"
  >
    <ion-row>
      <ion-col>
        <div
          class="ship-to order-info-subtitle"
          data-cy="submitted-order-ship-to-label"
        >
          {{ 'i18n.confirmationPage.shipTo' | translate }}
        </div>
      </ion-col>
    </ion-row>
  </ion-col>

  <ion-col
    *ngIf="showFullInfo"
    size-xl="3"
    size-l="3"
    size-md="3"
    size-s="12"
    size-xs="12"
  >
    <ion-row>
      <ion-col>
        <div
          class="order-info-value shipping-address-value"
          data-cy="submitted-order-address-text"
        >
          <ng-container *ngIf="!shipToInFlight; else shipToSpinner">
            <ng-container
              *ngIf="
                !!shipToCustomer &&
                  shipToCustomer?.customerNumber ===
                    orderHeader?.shipToCustomer;
                else customerOrderAddress
              "
            >
              {{ shipToCustomer?.customerName }}
              #{{ shipToCustomer?.customerNumber }} <br />
              <ng-container *ngIf="!!orderHeader?.shipToDepartment">
                {{
                  ' (' +
                    (shipToDepartmentName | titlecase) +
                    ' #' +
                    orderHeader?.shipToDepartment +
                    ')'
                }}<br />
              </ng-container>
              {{ shipToCustomer?.address1 }} &nbsp;
              {{ shipToCustomer?.address2 ? shipToCustomer?.address2 : '' }}
              <br />
              {{ shipToCustomer?.city }}, {{ shipToCustomer?.state }}
              {{ shipToCustomer?.zip | zipcode }}
            </ng-container>
            <ng-template #customerOrderAddress>
              {{ customer?.address1 }} &nbsp;
              {{ customer?.address2 ? customer?.address2 : '' }}<br />
              {{ customer?.city }}, {{ customer?.state }}
              {{ customer?.zip | zipcode }}
            </ng-template>
          </ng-container>
          <ng-template #shipToSpinner>
            <ion-spinner
              name="circles"
              class="ship-to-spinner"
              data-cy="loading-spinner"
            ></ion-spinner>
          </ng-template>
        </div>
      </ion-col>
    </ion-row>
  </ion-col>
</ion-row>

<ion-row *ngIf="showFullInfo" class="order-info-si-row">
  <div class="order-info-subtitle" data-cy="submitted-order-instructions-label">
    {{ 'i18n.confirmationPage.specialInstructions' | translate }} &nbsp;
  </div>
  <div
    class="order-info-value special-instructions-text"
    data-cy="submitted-order-instructions-text"
  >
    {{ orderHeader?.specialDeliveryInstructions || 'None' }}
  </div>
</ion-row>

<ng-container
  *ngIf="
    this.platformService?.platformType ===
    this.platformService?.platformEnum?.mobile
  "
>
  <ion-item
    *ngIf="showFullInfo && isDealsAvailable"
    class="banner-note mobile wrap item-text-wrap"
  >
    <ion-label data-cy="order-details-deals-note-text">
      <span class="note-bold" data-cy="submitted-order-note-label">
        {{ 'i18n.common.note' | translate }}
      </span>
      <span class="note-regular" data-cy="submitted-order-note-text">
        {{ 'i18n.confirmationPage.dealsNoteOnDetails' | translate }}
      </span>
    </ion-label>
  </ion-item>

  <ion-button
    (click)="collapseExpandDealsInfo()"
    class="usf-green-link-button no-border-button"
    [ngClass]="{ expanded: showFullInfo, collapsed: !showFullInfo }"
    data-cy="submitted-order-note-label-button"
    fill="clear"
  >
    <ng-container *ngIf="!showFullInfo; else lessButtonContainer">
      <label data-cy="submitted-order-note-label-button-text">
        {{ 'i18n.common.viewMore' | translate }}
      </label>
      &nbsp;
      <ion-icon
        name="chevron-down-outline"
        data-cy="submitted-order-note-label-button-icon"
      >
      </ion-icon>
    </ng-container>
    <ng-template #lessButtonContainer>
      <label data-cy="submitted-order-note-label-button-text">
        {{ 'i18n.common.viewLess' | translate }}
      </label>
      &nbsp;
      <ion-icon
        name="chevron-up-outline"
        data-cy="submitted-order-note-label-button-icon"
      >
      </ion-icon>
    </ng-template>
  </ion-button>
</ng-container>
